import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Box, Typography, Divider } from '@mui/material';
import ApiRequestService from '../../../component/ApiRequestService';
import { NotificationManager } from 'react-notifications';
import SFUserDetailModal from './SFUserDetailModal';


const SFUserName = ({ userName }) => {

    const [showModal, setShowModal] = useState(false);

    return (
        <div>
            <Button variant='text' onClick={() => {
                setShowModal(true);
            }}>
                {userName}
            </Button>

            <SFUserDetailModal
                open={showModal}
                userName={userName}
                handleClose={() => setShowModal(false)}
            />
        </div>
    );
}



export default SFUserName;
